module.exports = (__webpack_require__(14))(51);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/create-react-class/index.js from dll-reference vendor_library
// module id = 67
// module chunks = 0